import Cookies from 'cookie-universal'
import { useQuery } from '@tanstack/react-query'
import { api } from '@mc/legacy-api'

const EXPERIENCE_ENDPOINT = '/jsonapi/v1/user/experience'
export const CONSUMER = 'consumer'
export const ENTERPRISE = 'enterprise'

type Features = {
  bookmarks: boolean
  myList: boolean
  myProgress: boolean
  shareThisTrailer: boolean
  shareLesson: boolean
  singleClassUser: boolean
  notes: boolean
}

export type ExperienceData = Features & {
  name: string
}

type EndpointResponse = Partial<Features> & {
  name: string
}

export type ExperienceApiResponse =
  | {
      isReady: false
      isError: boolean
      data: undefined
    }
  | {
      isReady: true
      isError: false
      data: ExperienceData
    }

// If the API response does not return a feature value, it's assumed enabled
export const defaultFeatures = {
  bookmarks: true,
  myList: true,
  myProgress: true,
  shareThisTrailer: true,
  shareLesson: true,
  singleClassUser: false,
  notes: true,
}

export const fetchExperience: () => Promise<EndpointResponse> = async () =>
  (await api.get(EXPERIENCE_ENDPOINT)) as EndpointResponse

export const useExperienceApi: () => ExperienceApiResponse = () => {
  const isLoggedIn = Cookies().get('_mcl') === 1
  const { data, status } = useQuery(['experience'], fetchExperience, {
    refetchOnWindowFocus: false,
    enabled: isLoggedIn,
  })

  if (!isLoggedIn) {
    const loggedOutExperienceData = {
      name: CONSUMER,
      ...defaultFeatures,
    }

    return {
      isReady: true,
      isError: false,
      data: loggedOutExperienceData,
    }
  }

  const isReady = status === 'success' && !!data
  const isError = status === 'error'

  if (isReady) {
    return {
      isReady: true,
      isError: false,
      data: {
        ...defaultFeatures,
        ...data,
      },
    }
  }

  return {
    isReady: false,
    isError,
  }
}
